module.exports = __webpack_public_path__ + "img/lg_ring_g_i_1_null@2x.633b4c40.png";